module.exports = __webpack_public_path__ + "assets/icons/ic_add_circle_24px.svg";